module.exports = __webpack_public_path__ + "img/gui_gjj.9518dab8.png";